import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { getToken } from '../../../../../helpers/Jwt';
import { Formik, Form, Field, ErrorMessage } from "formik";

import * as Yup from "yup";
import axios from 'axios';
import ActionComponent from '../../../../Activity/Component/ActionComponent';

const Employment = ({ id_employee, employment, onRefresh }) => {

    const [isForm, setIsForm] = useState(false);
    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_EMPLOYMENT = "/api/hrppsu/employee/employment";

    const [initialValues, setInitialValues] = useState({
        // name: "",
        // category: "",
        // type: "",
        // parent_account: null,
    });

    const validationSchema = Yup.object().shape({
        // name: Yup.string().required("Nama Akun wajib diisi."),
        // category: Yup.string().required("Kategori Akun wajib diisi."),
        // type: Yup.string().required("Jenis Akun wajib dipilih."),
    });

    const onSubmit = async (values, actions) => {
        try {
            const payload = {
                ...values,
                id_employee
            };

            await axios.post(`${BASE_URL}${PATH_EMPLOYMENT}`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${getToken()}`,
                },
            });
            onRefresh();
            setIsForm(false);
        } catch (error) {
            console.error("Error submitting form:", error);
            setError("Gagal menyimpan data. Silakan coba lagi.");
        } finally {
            actions.setSubmitting(false);
        }
    };

    return (
        <div className='w-full p-5'>
            <div className='flex items-center justify-between'>
                <h1>Employment</h1>
            </div>
            <div className='flex mt-5'>
                <div className='w-1/3'>
                    <h2 className='font-bold text-xl'>Employment data</h2>
                    <p className='text-sm'>Your Data Information related to company.</p>
                </div>
                <div className={isForm ? 'hidden' : 'w-full p-3'}>
                    <div className='justify-end flex'>
                        <button
                            type="button"
                            className={`bg-gray-200 hover:bg-gray-400 text-black py-0 px-4 rounded focus:outline-none focus:ring focus:ring-gray-200`}
                            onClick={() => setIsForm(!isForm)}> Edit </button>
                    </div>
                    {employment?.map((data) => (
                        <div className='flex justify-between'>
                            <p className='p-1 text-xs font-bold'>{data?.label}</p>
                            <p className='p-1 text-xs text-end'>{data?.value}</p>
                        </div>))}
                </div>

                <div className={!isForm ? 'hidden' : 'w-full p-3'}>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                        enableReinitialize
                    >
                        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                            <Form onSubmit={handleSubmit}>
                                {employment.map((data, index) => {
                                    const nameAttribute = data.key;
                                    const typeAttribute = data.type;
                                    const labelAttribute = data.label;
                                    const defaultValue = data.value;

                                    return (
                                        <ActionComponent
                                            callChange={(value) => {
                                                if (typeAttribute.value === 'text') {
                                                    setFieldValue(nameAttribute.value, value);
                                                }
                                            }}
                                            key={index}
                                            action={{
                                                "element": "input",
                                                "action_attribute": [
                                                    {
                                                        "key": "type",
                                                        "value": typeAttribute
                                                    },
                                                    {
                                                        "key": "name",
                                                        "value": nameAttribute
                                                    },
                                                    {
                                                        "key": "placeholder",
                                                        "value": labelAttribute
                                                    },
                                                    {
                                                        "key": "className",
                                                        "value": "my-1 p-2 block w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue"
                                                    }
                                                ],
                                            }}
                                            custom={false}
                                            defaultValue={defaultValue}
                                        />
                                    );
                                })}

                                <div className="flex items-center justify-end mt-5">
                                    <button
                                        type="button"
                                        className={`mx-2 bg-gray-200 hover:bg-gray-400 text-black font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-gray-200 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
                                        onClick={() => setIsForm(false)}>
                                        Batal
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className={`bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:ring-blue-200 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                                            }`}
                                    >
                                        {isSubmitting ? 'Menyimpan...' : 'Simpan'}
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
    )
}

export default Employment;